import { Component, EventEmitter, Input, Output } from '@angular/core';

import { multiSelectKeyValueType, TextType } from '..';

@Component({
  selector: 'app-label-multi-select',
  templateUrl: './label-multi-select.component.html',
  styleUrls: ['./label-multi-select.component.scss']
})
export class LabelMultiSelectComponent {
  // provides content of label
  @Input() labelText!: string;

  // provides label text type
  @Input() labelTextType!: TextType;

  // to disable dropdown
  @Input() isDisabled = false;

  // SelectedItemList stores the value of the items which are selected.
  @Input() selectedItemList: string[] = [];

  // This dataset will be used as options in select and it should be passed as [{ value: 'steak-0', name: 'Steak' }].
  @Input() data: multiSelectKeyValueType[] = [];

  // Event emitter when a dropdown value is selected.
  @Output() multiSelectChangeHandler: EventEmitter<string[]> = new EventEmitter<
    string[]
  >();

  /**
   * Handles change in selection of items.
   *
   * @param {string[]} selectedItems
   */
  onSelectionChange = (selectedItems: string[]) =>
    this.multiSelectChangeHandler.emit(selectedItems);
}
